import React from "react";
import img from "../AboutUsPage/images/logobg.png";

const AboutUsHero = () => {
  return (
    <section
      className="aboutus-wrap fade-section"
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "70px 0",
        background: "linear-gradient(135deg, #E6F1FB 0%, #F4F9FF 100%)",
      }}
    >
      {/* floating glow bubbles */}
      <div
        aria-hidden
        className="bubble bubble-tl"
        style={{
          position: "absolute",
          top: "-140px",
          left: "-140px",
          width: "420px",
          height: "420px",
          borderRadius: "50%",
          background:
            "radial-gradient(closest-side, rgba(142, 179, 213, 0.35), rgba(142, 179, 213, 0) 80%)",
          filter: "blur(2px)",
          animation: "floatPulse 10s ease-in-out infinite alternate",
          pointerEvents: "none",
        }}
      />
      <div
        aria-hidden
        className="bubble bubble-br"
        style={{
          position: "absolute",
          bottom: "-160px",
          right: "-160px",
          width: "520px",
          height: "520px",
          borderRadius: "50%",
          background:
            "radial-gradient(closest-side, rgba(170, 195, 221, 0.35), rgba(170, 195, 221, 0) 80%)",
          filter: "blur(2px)",
          animation: "floatPulse 12s ease-in-out 1s infinite alternate",
          pointerEvents: "none",
        }}
      />

      {/* content container */}
      <div
        className="px-3 px-md-4 mx-auto position-relative"
        style={{ maxWidth: "74%", zIndex: 1 }}
      >
        <div
          className="aboutus-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(280px, 48%) 1fr",
            gap: "42px",
            alignItems: "center",
          }}
        >
          {/* Left: Image */}
          <div style={{ width: "100%" }}>
            <img
              src={img}
              alt="Vertex Suite integrations and channels"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                borderRadius: "12px",
              }}
            />
          </div>

          {/* Right: Content */}
          <div>
            <p
              style={{
                margin: 0,
                fontSize: "34px",
                lineHeight: 1.1,
                fontFamily: "'Inter', sans-serif",
                fontWeight: 650,
                color: "#1C1C1C",
              }}
            >
              <span
                className="fw-semi-bold"
                style={{
                  fontSize: "2rem",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  background:
                    "linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                Vertex Suite
              </span>
            </p>

            <p
              style={{
                marginTop: "8px",
                marginBottom: "0px",
                fontSize: "20px",
                color: "#6B6B6B",
                fontWeight: 400,
                fontFamily: "Inter",
                lineHeight: 1.3,
                maxWidth: 760,
              }}
            >
              is a Meta-approved business messaging partner offering a
              sector-agnostic SaaS platform. We automate workflows over WhatsApp
              to help businesses scale smarter operations- all within a no-code,
              intuitive environment.
            </p>

            <p
              style={{
                marginTop: "8px",
                fontSize: "20px",
                color: "#6B6B6B",
                fontWeight: 400,
                fontFamily: "Inter",
                lineHeight: 1.3,
                maxWidth: 760,
              }}
            >
              With AI-powered tools, brands can automate conversations, deliver
              personalized experiences, and improve efficiency at scale- all
              from one unified platform.
            </p>
          </div>
        </div>
      </div>

      {/* keyframes + responsive */}
      <style>
        {`
          /* background floating bubbles */
          @keyframes floatPulse {
            0%   { transform: translate3d(0, 0, 0) scale(1);    opacity: .65; }
            50%  { transform: translate3d(12px, -10px, 0) scale(1.06); opacity: .85; }
            100% { transform: translate3d(0, 0, 0) scale(1.02); opacity: .70; }
          }

          /* fade-in whole section on mount */
          .fade-section {
            opacity: 0;
            transform: translateY(-40px);
            animation: fadeInTop 1s ease-out forwards;
          }

          @keyframes fadeInTop {
            from { opacity: 0; transform: translateY(-40px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          /* Respect reduced motion */
          @media (prefers-reduced-motion: reduce) {
            .fade-section { animation: none !important; opacity: 1 !important; transform: none !important; }
          }

          /* Responsive */
          @media (max-width: 992px) {
            .aboutus-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </section>
  );
};

export default AboutUsHero;
